import { Button, ButtonProps, Stack } from 'src/components/mui';
//@ts-ignore
import React from 'react';

export const NavItem = ({ children, sx, ...rest }: ButtonProps) => {
  return (
    <Stack justifyContent="center">
      <Button
        sx={{
          ...sx,
        }}
        variant="text"
        {...rest}
      >
        {children}
      </Button>
    </Stack>
  );
};
